import React from "react";
import Cardo from "./Cardo";
import Pro from "./Pro";

const CoffeeShop = () => {
  return (
    <div id="coffeeshop">
      <Cardo />
      <Pro />
    </div>
  );
};

export default CoffeeShop;
